// @flow

import { useEffect } from 'react';

export const useOutsideClick = (
  ref: {| current: ?React$ElementRef<string> |},
  callback: () => void
) => {
  const handleClick = (e: MouseEvent) => {
    if (
      ref.current &&
      e.target instanceof Node &&
      !ref.current.contains(e.target)
    ) {
      callback();
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  });
};
